import { render, staticRenderFns } from "./UserAvatar.vue?vue&type=template&id=25a6f451"
import script from "./UserAvatar.vue?vue&type=script&lang=js"
export * from "./UserAvatar.vue?vue&type=script&lang=js"
import style0 from "./UserAvatar.vue?vue&type=style&index=0&id=25a6f451&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports